<script>
  import { Doughnut } from 'vue-chartjs'


  export default {
    extends: Doughnut,
    data () {
      return {
        chartData: {
          labels: ["מוסלמים", "נוצרים", "דרוזים"],
          datasets: [{
              borderWidth: 1,
                 borderColor: [
              'rgba(27, 94, 32,1)',
              'rgba(244, 81, 30, 1)',
              'rgba(2, 136, 209, 1)'             
              ],
              backgroundColor: [
              'rgba(124, 179, 66, 0.9)',
              'rgba(244, 81, 30, 0.9)',
              'rgba(2, 136, 209, 0.9)',        
              ],
              data: this.cData
            }]
        },
        options: {
          legend: {
            display: true
          },
          responsive: true,
          maintainAspectRatio: false
        }
      }
    },
    props: ['cData'],
    mounted () {
      this.chartData.data = this.cData;
      this.renderChart(this.chartData, this.options)
    },
    watch: {
    cData(){
        if (this.cData.length) {
            this.renderChart({
          labels: ["מוסלמים", "נוצרים", "דרוזים"],
          datasets: [{
              borderWidth: 1,
              borderColor: [
              'rgba(27, 94, 32,1)',
              'rgba(244, 81, 30, 1)',
              'rgba(2, 136, 209, 1)'             
              ],
              backgroundColor: [
              'rgba(124, 179, 66, 0.9)',
              'rgba(244, 81, 30, 0.9)',
              'rgba(2, 136, 209, 0.9)',        
              ],
              data: this.cData
            }]
            }, {responsive: true, maintainAspectRatio: false})
        }else{
            this._chart.destroy()
        }
    }
}
  }
</script>